import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Container } from "react-bootstrap";
import debounce from "lodash.debounce";

import "./OrderList.scss";
import messages from '../../assets/i18n';
import { Creators as actionOrderList } from "../../store/ducks/orderList";
import ItemList from '../../containers/ItemList/ItemList'
import havePermissionTo from "../../utils/havePermission";
import textStatusOrder from '../../helpers/convertStatusOrder';
import textNatureOrder from '../../helpers/convertNatureOrder';
import textStatusComercial from '../../helpers/convertStatusConciliation';
import { ButtonStandard, ToastMessage } from "../../components";
import { downloadFile } from '../../utils/utilFile';
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import formatDate from '../../helpers/formatDate';
import { ORDER_REPORT_HEADERS } from '../../utils/constants';
import html2pdf from "html2pdf.js";

function OrderList(props) {

	const [arrChecked, setArrCheckedHiddden] = useState([]);

	const filters = useSelector(state => state.filter);

	const dispatch = useDispatch();
	const history = useHistory();

	const lang = useSelector(state => state.language.name);
	const orders = useSelector(state => state.orders);
	const selectedOrder = useSelector(state => state.orders.selectedOrder);
	const permissions = useSelector(state => state.authorization.permissions);
	const eventsLogToast = useSelector(state => state.orders.eventsLogToast);

	const getOrders = useCallback((page, filtros, size) => dispatch({ type: "GET_ORDERS", page: page, filtro: filtros, size: size }), [dispatch]);
	const getOrdersDownload = useCallback((filtros, size) => dispatch({ type: "GET_ORDERS_DOWNLOAD", filtro: filtros, size: size }), [dispatch]);

	const dispatchLoadId = loadId => dispatch({	type: "LOAD_ID", loadId: loadId });
	const dispatchResultStep = resultStep => dispatch({	type: "RESULT_STEP", resultStep: resultStep });

	const setCleanOrders = bindActionCreators(actionOrderList.cleanOrders, dispatch);
	const setOrderList = bindActionCreators(actionOrderList.setOrder, dispatch);

	const debounceLoadList = debounce((page = undefined, filtros = filters, size = undefined) => {
		getOrders(page, filtros, size);
	}, 100);

	const loadList = useCallback(debounceLoadList, [getOrders]);

	useEffect(() => {
		setCleanOrders();
		loadList();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loadList])

	useEffect(() => {
		if (orders.detailedReport.length > 0) {
			let reportArray = [];
			let fileHeaders = []

			for (let i = 0; i < orders.detailedReport.length; i++) {
				let newItem = []
				for (let j = 0; j < ORDER_REPORT_HEADERS.length; j++) {
					if (i === 0) {
						fileHeaders.push(messages[lang].detailedOrderReport[ORDER_REPORT_HEADERS[j]])
					}

					let newValue
					if (ORDER_REPORT_HEADERS[j].includes('cnpj')) {
						newValue = orders.detailedReport[i][ORDER_REPORT_HEADERS[j]] ? cnpjMask(orders.detailedReport[i][ORDER_REPORT_HEADERS[j]]) : ''
					} else {
						newValue = orders.detailedReport[i][ORDER_REPORT_HEADERS[j]] ? orders.detailedReport[i][ORDER_REPORT_HEADERS[j]] : ''
					}

					if (typeof newValue === 'string' && newValue.includes(',')) {
                        newValue = newValue.replace(",", "/");
                    }

					newItem.push(newValue)
				}
				reportArray.push(newItem)
			}

			const filename = messages[lang].ordersList + `-detalhado.csv`;	
									
			const textCsv = mountCsvText([fileHeaders, ...reportArray]);
			downloadFile(textCsv, filename);
			dispatch({ type: "SET_DETAILED_REPORT", payload: [] });			
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orders.detailedReport])

	useEffect(() => {
		if (orders.eventsLog && orders.eventsLog.length > 0) {
			let reportArray = [];
			
			let fileHeaders = [
				"ID", 
				"Descrição",
				"Tipo de Evento", 
				"Data do Evento",
				"SKU",
				"Valor",
				"Quantidade"
			];

			for (let i = 0; i < orders.eventsLog.length; i++) {
				let newItem = [];
				let eventRow = orders.eventsLog[i];

				newItem.push(eventRow.id || '');
				newItem.push(eventRow.descricao || '');
				newItem.push(eventRow.tipoEvento || '');
				newItem.push(eventRow.dataEvento || '');
				newItem.push(eventRow.sku || '');
				newItem.push(eventRow.valor || '');
				newItem.push(eventRow.quantidade || '');
				
				for (let j = 0; j < newItem.length; j++) {
					if (typeof newItem[j] === 'string' && newItem[j].includes(',')) {
						newItem[j] = newItem[j].replace(/,/g, "/");
					}
				}

				reportArray.push(newItem);
			}

			const filename = messages[lang].eventsList + `.csv`;	
									
			const textCsv = mountCsvText([fileHeaders, ...reportArray]);
			downloadFile(textCsv, filename);
			
			dispatch({ type: "SET_EVENTS_LOG", payload: [] });			
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orders.eventsLog])

	const setArrChecked = (arrChecked) => {
		setArrCheckedHiddden(arrChecked);
		if (orders) {
			setOrderList(orders.orderList.filter(order => {
					return arrChecked.indexOf(order.id) >= 0
				})
			);
		}
	}

	const handleHasMore = () => {
		loadList(orders.page, filters);
	}

	const handleCheckedLoad = (loadId) => {
		dispatchLoadId(loadId);
		props.history.push(`/load-details`);
	};

	const handleCheckedConciliation = (orderId) => {
		dispatchResultStep(true);
		setArrChecked([orderId]);
		props.history.push(`/conciliation-status`);
	};

	const titleTable = messages[lang].orders;

	const header = [
		"",
		messages[lang].Order,
		messages[lang].Parts,
		messages[lang].issue,
		messages[lang].status,
		messages[lang].nature,
		messages[lang].sampleOriginOrder,
		messages[lang].weekAndYear,
		messages[lang].distributionCenter,
		messages[lang].marca,
		messages[lang].numberLoads,
		messages[lang].deliveryDate,
		messages[lang].provider,
		messages[lang].conciliation,
	];

	const listTable = 
		orders 
			&& orders.orderList 
			.map(value => ([
				{
					checkbox: {
						arrChecked: arrChecked,
						id: value.id,
						setArrChecked: setArrChecked,
					},
				},
				{
					text: value.id,
					onClick: () => {
						dispatch({
							type: 'SET_SELECTED_ORDER',
							payload: {
								id: value.id,
								data: value
							}
						})
					},
				},
				value.qtCompra,
				{
					text: value.dtEmissao,
					type: 'data',
				},
				{
					text: value.prePo === 'Y' ? messages[lang].preRegistrationStatus : textStatusOrder(lang, value.status),
					maxLength: 30,
				},
				{
					text: textNatureOrder(lang, value.naturezaPedido),
					maxLength: 10,
				},
				value.amostraPedido || value.origemPedido,
				value.calendarioComercial ? ((value.calendarioComercial.semanaComercial ? value.calendarioComercial.semanaComercial : '') + '/' + (value.calendarioComercial.dataInicial ? value.calendarioComercial.dataInicial.split('-')[0] : '')) : '',
				{
					text: value.localizacaoFisica && value.localizacaoFisica.nome ? value.localizacaoFisica.nome : '',
					tooltip: value.localizacaoFisica && value.localizacaoFisica.nome ? value.localizacaoFisica.nome : '',
					maxLength: 10,
				},
				value.departamento ? value.departamento : '',
				{
					text: value.carga && value.carga.id ? value.carga.id : '',
					onClick: havePermissionTo('load-details', permissions) && value.carga && value.carga.id ? () => {handleCheckedLoad(value.carga.id)} : undefined,
				},
				{
					text: value.carga 
						&& value.carga.agendamentos[0] 
						&& value.carga.agendamentos[0].dtEntrega 
							? `${formatDate(value.carga.agendamentos[0].dtEntrega)} ${value.carga.agendamentos[0].horaEntrega}`
							: '',					
				},
				{
					text: value.fornecedor && value.fornecedor.nome ? value.fornecedor.nome : '',
					tooltip: value.fornecedor && value.fornecedor.nome ? value.fornecedor.nome : '',
					maxLength: 20,
				},
				{
					text: textStatusComercial(lang, value.conciliacaos),
					type: 'statusConciliacao',
					onClick: havePermissionTo('conciliation-status', permissions) ? () => {handleCheckedConciliation(value.id)} : undefined,
				},
	]));

	useEffect(() => {
		if (!listTable.length > 0
				&& !orders.isLoading
				&& !orders.hasMoreIsLoading
				&& !orders.error) {
			loadList(orders.page);
		}
	}, [listTable, loadList, orders.isLoading, orders.page, orders.hasMoreIsLoading, orders.error]);

	useEffect(() => {
		if (selectedOrder.id) {
			history.push('/order-options')
		}	
		// eslint-disable-next-line react-hooks/exhaustive-deps	
	}, [selectedOrder]);
	
	const handleDownloadOrders = () => {
		const transformOrdersToDownload = listTable.map(orderLine => (
			orderLine.filter( (order, index) => index !== 0 ).map((orderColumn) => getTextColumn(orderColumn))
		));

		transformOrdersToDownload.map(orders => {
			orders[13] = orders[12][1];
			orders[12] = orders[12][0];

			return orders;
		})

		let headerTable = header;
		headerTable[13] = messages[lang].conciliacaoComercial
		headerTable[14] = messages[lang].conciliacaoFiscal
		
		const filename = messages[lang].ordersList + `.csv`;
		const textCsv = mountCsvText([headerTable, ...transformOrdersToDownload]);
		downloadFile(textCsv, filename);
	}

	const handleDownloadDetailedOrders = (filters) => {
		dispatch({
			type: 'GET_DETAILED_REPORT',
			payload: filters
		})
	}

	const handleDownloadEventsLog = (filters) => {
		dispatch({
			type: 'GET_EVENTS_LOG',
			payload: filters
		})
	}

	const handleDownloadAllOrders = () => {

		if(orders.orderListDownload.length > 0) {

			let transformOrdersToDownload = 
				orders.orderListDownload 
					.map(value => ([
						value.id,
						value.qtCompra,
						value.dtEmissao,
						value.prePo === 'Y' ? messages[lang].preRegistrationStatus : textStatusOrder(lang, value.status),
						textNatureOrder(lang, value.naturezaPedido),
						value.amostraPedido || value.origemPedido,
						value.calendarioComercial ? ((value.calendarioComercial.semanaComercial ? value.calendarioComercial.semanaComercial : '') + '/' + (value.calendarioComercial.dataInicial ? value.calendarioComercial.dataInicial.split('-')[0] : '')) : '',
						value.localizacaoFisica && value.localizacaoFisica.nome ? value.localizacaoFisica.nome : '',
						value.departamento ? value.departamento : '',
						value.carga && value.carga.id ? value.carga.id : '',
						value.carga 
								&& value.carga.agendamentos[0] 
								&& value.carga.agendamentos[0].dtEntrega 
									? `${formatDate(value.carga.agendamentos[0].dtEntrega)} ${value.carga.agendamentos[0].horaEntrega}`
									: '',					
						value.fornecedor && value.fornecedor.nome ? value.fornecedor.nome : '',
						textStatusComercial(lang, value.conciliacaos),
				]));

			transformOrdersToDownload = transformOrdersToDownload.map(orders => {
				orders[13] = orders[12][1];
				orders[12] = orders[12][0];

				return orders;
			})

			let headerTable = header;
			headerTable[13] = messages[lang].conciliacaoComercial
			headerTable[14] = messages[lang].conciliacaoFiscal

			const filename = messages[lang].ordersList + `.csv`;
			const textCsv = mountCsvText([headerTable, ...transformOrdersToDownload]);
			downloadFile(textCsv, filename);
		} else {
			getOrdersDownload(filters, 1000)
		}
	}

	const getTextColumn = (column) => {
		return (
			typeof column !== 'object'
				? column 
				: (column && column.text ? column.text : '')
		)
	}

	const mountCsvText = (arrayToText) => {
		const separator = ';';
		return arrayToText.reduce((csvText, currentRow) => {

			const rowText = currentRow.reduce((csvRow, currentColumn) => {
				return csvRow ? `${csvRow}${separator}${currentColumn}` : currentColumn
			}, '');

			return csvText ? `${csvText}\n${rowText}` : rowText
		}, '');
	}

	const cnpjMask = value => {
		
		if(!value) return ""

		let cleanValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

		let base = cleanValue.substring(0, 12);
		let checkerDigits = cleanValue.substring(12, 14);

		checkerDigits = checkerDigits.replace(/[^0-9]/g, '');

		let finalValue = base + checkerDigits;

		return finalValue
			.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
			.replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3})([A-Z0-9])/, '$1.$2')
			.replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3})([A-Z0-9])/, '$1/$2')
			.replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4})(\d)/, '$1-$2');
	}

	const generatePDF = async () => {
		var element = document.getElementById('itemGrid');

		var opt = {
			filename:     'gridPedidos.pdf',
			html2canvas:  { scale: 1},
			jsPDF:        { unit: 'in', format: 'a3', orientation: 'landscape' }
		  };

		html2pdf(element, opt);
	}

	const handleCloseToast = (show) => {
		if(eventsLogToast) {
			dispatch({
				type: 'SET_EVENTS_LOG_TOAST',
				payload: { ...eventsLogToast, showToast: show }
			})
		}
	}

	return (
		<Container className="order-list-body">

			<ToastMessage
				show={eventsLogToast ? eventsLogToast.showToast : false}
				setShow={handleCloseToast}
				message={eventsLogToast ? eventsLogToast.message : ""}
				toastClass={eventsLogToast ? eventsLogToast.messageType : "toast-error"}
			/>

			{(orders.loadingDetailedReport || orders.loadingEventsLog)?
			<div className="loader">
				<LoadingSpinner />    
			</div> 			
			: null
			}
			<Container className="px-4 d-flex justify-content-end">
				<ButtonStandard
					text={messages[lang].searchOrder}
					textClass="text-1"
					className="btn-sm default btn-outline-success btn-standard px-2 mr-2"
					onClick={event => getOrders(undefined, filters)}/>

				<ButtonStandard
					text={messages[lang].downloadOrders}
					textClass="text-1"
					className="dropdown btn-outline-success btn-sm btn-standard px-2 mr-2"
					disabled={orders.loadingDetailedReport}
					dropdownActions={
						[
							{
								label: messages[lang].downloadOrdersNormalVersion,
								action: handleDownloadOrders
							},
							{
								label: messages[lang].downloadOrdersFullVersion,
								action: event => handleDownloadDetailedOrders(filters)
							},
							{
								label: messages[lang].downloadEventsLog,
								action: event => handleDownloadEventsLog(filters)
							},
							{
								label: 'PDF',
								action: () => generatePDF()
							}
						]
					}/>	

				<ButtonStandard
					text={messages[lang].downloadAllOrders}
					isLoading={orders.isLoadingDownload}
					textClass="text-1"
                    className="btn-primary btn-sm btn-standard px-2 mr-2"
					onClick={handleDownloadAllOrders} />	

			</Container>
			<Container className="mt-1 pt-1 mb-4 pb-5">
				<ItemList
					header={header}
					titleTable={titleTable}
					listTable={listTable}
					isLoading={orders ? orders.isLoading : false}
					hasMore={orders.hasMore}
					handleHasMore={handleHasMore}
					hasMoreIsLoading={orders.hasMoreIsLoading}
					error={orders && orders.error ? [messages[lang].messageErrorListError.default] : undefined} 
					/>
			</Container>
		</Container>

	);
}
export default withRouter(OrderList);